import { AlertWindow } from '@sunwebgroup/uds-ui/alert-window'
import { Button } from '@sunwebgroup/uds-ui/button'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import {
  BookingDeletedAlertContent,
} from '@/scopes/account/booking-details/pages/components/ManageBookingSection/BookingDeletedAlertContent'
import {
  BookingDeletionErrorAlertContent,
} from '@/scopes/account/booking-details/pages/components/ManageBookingSection/BookingDeletionErrorAlertContent'
import {
  ConfirmDeletionAlertContent,
} from '@/scopes/account/booking-details/pages/components/ManageBookingSection/ConfirmDeletionAlertContent'
import styles
  from '@/scopes/account/booking-details/pages/components/ManageBookingSection/ManageBookingSection.module.css'
import {
  getDeleteBookingRequestStatus,
  getIsDeleteActionShown,
  getIsDeleteDialogOpen,
} from '@/scopes/account/booking-details/pages/selectors'

export function DeleteAction() {
  const { formatMessage } = useIntl()
  const open = useBookingDetailsStore(getIsDeleteDialogOpen)
  const { bookingDeletionDialogOpened, bookingDeletionDialogClosed } = useBookingDetailsActions()
  const shouldBeShown = useBookingDetailsStore(getIsDeleteActionShown)

  if (!shouldBeShown) {
    return null
  }

  return (
    <AlertWindow.Root open={open} onOpenChange={value => value ? bookingDeletionDialogOpened() : bookingDeletionDialogClosed()}>
      <AlertWindow.Trigger>
        <Button variant="transparentPrimary" className={styles.actionButton}>
          <Button.Icon glyph="TrashCan" />
          {formatMessage({ id: 'booking_details_manage_booking_delete_button_label' })}
        </Button>
      </AlertWindow.Trigger>
      <DeleteAlertContent />
    </AlertWindow.Root>
  )
}

function DeleteAlertContent() {
  const status = useBookingDetailsStore(getDeleteBookingRequestStatus)

  if (status === 'success') {
    return <BookingDeletedAlertContent />
  }

  if (status === 'error') {
    return <BookingDeletionErrorAlertContent />
  }

  return <ConfirmDeletionAlertContent />
}
